// Elements
const header = document.querySelector('.header');
const megaMenus = header?.querySelectorAll('.mega-menu');
const closeButtons = header?.querySelectorAll('.header__close');
const backButtons = header?.querySelectorAll('.header__back');
const toggler = header?.querySelector('.header__toggler');

// Add class on scroll
const HEADER_SCROLL = 'header--scrolled';
const HEADER_ACTIVE = 'header--active';
const MEGAMENU_ACTIVE = 'mega-menu--active';

// Is an animation frame ticking?
let ticking: boolean = false;

const handleScroll = () => {
  if (!ticking) {
    requestAnimationFrame(() => {
      header.classList.toggle(HEADER_SCROLL, window.scrollY > 0);
      ticking = false;
    });
    ticking = true;
  }
};

const handleTogglerClick = () => {
  header.classList.toggle(HEADER_ACTIVE);
  toggler.setAttribute('aria-expanded', 'true');

  [...closeButtons].forEach((button) => {
    button.setAttribute('aria-expanded', 'true');
  });
};

const closeMegaMenus = () => {
  [...megaMenus].forEach((megaMenu) => {
    megaMenu.classList.remove(MEGAMENU_ACTIVE);
  });
};

const removeAllButtonsExpanded = () => {
  [...closeButtons].forEach((mixedButton) => {
    mixedButton.setAttribute('aria-expanded', 'false');
  });
};

const handleCloseButtonClick = () => {
  header.classList.remove(HEADER_ACTIVE);
  toggler.setAttribute('aria-expanded', 'false');

  removeAllButtonsExpanded();
  closeMegaMenus();
};

const handleBackButtonClick = (e: MouseEvent) => {
  const self = e.currentTarget as HTMLButtonElement;
  const submenu: HTMLElement = self.closest('nav.mega-menu');
  submenu.classList.remove(MEGAMENU_ACTIVE);
  self.setAttribute('aria-expanded', 'false');
};

const init = () => {
// Handle header class on scroll
  window.addEventListener('scroll', handleScroll, { passive: true });

  // Open menu on 'toggler' click
  toggler?.addEventListener('click', handleTogglerClick);

  // Close menu on close button click
  [...closeButtons].forEach((closeButton) => {
    closeButton.addEventListener('click', handleCloseButtonClick);
  });

  // Close submenu on back button click
  [...backButtons].forEach((backButton) => {
    backButton.addEventListener('click', handleBackButtonClick);
  });
};

export default init;
